export interface AgreementDetails {
  agreementType: AgreementType;
  startDate: string;
  endDate: string;
  continueToOpenListingOnExpiration: boolean;
}

export enum AgreementType {
  Exclusive = 'Exclusive',
  Open = 'Open',
  Sole = 'Sole',
}

export enum AgreementLength {
  ThirtyDays = '30',
  SixtyDays = '60',
  NinetyDays = '90',
  OneHundredTwentyDays = '120',
  SpecificDate = 'specificDate',
}
